<div class="row col-12 col-sm-12 my-account-container" [ngClass]="isMobile? 'px-0':'pr-0'">
  <div *ngIf="!isMobile" class="col-3 col-sm-3 my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'MyRequestNavNode'"
      [childNavState]="'BreakApplicationFormNAVNode'"></app-my-account-left-sidenav>
  </div>

  <div class="myAccountMyProfile " [ngClass]="isMobile? 'col-12 px-0' :'col-9 col-sm-9 pr-0 my-account-right-nav'"
    *ngIf="canLoadPage$|async">
    <ng-container>
      <div *ngIf="submittedSuccessFully" class="warranty-header-success-msg">
        <div class="content">
          <p class="core-submit-msg" [innerHTML]="'common.text_break_submission_NA_text1'|cxTranslate">
          </p>
        </div>
      </div>
      <div *ngIf="savedSuccessFully" class="warranty-header-success-msg">
        <div class="content">
          <p class="core-submit-msg" [innerHTML]="'common.text_break_submission_NA_text2' | cxTranslate">
          </p>
        </div>
      </div>
      <div *ngIf="isFormContainsError" class="warranty-header-alert-msg " style="display: block;">
        <div class="content">
          <p>{{ 'common.form_global_error' | cxTranslate }}</p>
        </div>
      </div>
      <div *ngIf="isFormFilledSuccessfully && !submittedSuccessFully"
        class="warranty-header-warning-msg warning-alert-msg" style="display: block;">
        <div class="content">
          <p>{{ 'common.breakForm_submit_review_carefully' | cxTranslate }}</p>
        </div>
      </div>
    </ng-container>
    <h1 class="myProfileTopHeader m-0 brakeApplicationForm-header">
      {{'common.Bendix_break_application'|cxTranslate}}
    </h1>
    <div class=" topdivSection fs-18">
      <div class="topSection" *ngIf="!isNotNewForm">
        <p>{{'common.Bendix_break_application_msg1'|cxTranslate}}</p>
        <p [innerHtml]="'common.Bendix_break_application_msg2'|cxTranslate"></p>
        <p>{{'common.Bendix_break_application_msg3'|cxTranslate}}</p>
        <p class="withbolder">{{'common.Bendix_break_application_msg4'|cxTranslate}}
          <a [href]='latestDocUrl$ |async ' target="_blank">
            
            <b>Brake Application Request Form Process</b></a>
        </p>
      </div>
      <form [formGroup]="brakeApplicationForm">
        <div class="formsection">
          <div class="customerInfosection" [class.pt-4]="isNotNewForm">
            <p class="fsize_24"><b>{{'common.text_ADB_customer_information'|cxTranslate}}</b></p>
            <div class="formButtonSection customerInfoBtns">
              <div class="leftsection"><b>{{'common.myaccount_brakeform_customer_id'|cxTranslate}}</b></div>
              <div class="Formbuttons">
                <button (click)="onSave()" class="btn btn-primary saveForLater"
                  [disabled]="submittedSuccessFully">{{'common.checkout_summary_adb_saveFL'|cxTranslate}}
                  <img width="20px" src="/icons/link-white.svg" alt=""></button>
                <button (click)="forReview()" class="btn btn-blue" [disabled]="submittedSuccessFully">
                  {{'common.myaccount_brakeform_brake_final_review'|cxTranslate}}</button>
                <button (click)="onSubmit()" class="btn btn-primary"
                  [disabled]="submittedSuccessFully || !isFormFilledSuccessfully"
                  *ngIf="checkFormClicked">{{'common.text_warranty_submit_button'|cxTranslate}}
                  <img width="20px" src="/icons/link-white.svg" alt=""></button>
              </div>
            </div>
            <div class="customerdataformsection">
              <div class=" customerIdDropdowntag form-group select-boxer">
                <select name="customer" id="customerId" formControlName="soldToNumber" class="form-control">
                  <option *ngFor="let opt of customerIdFromCommonEnd" [value]="opt?.uid"
                    [selected]="opt?.uid == bAF?.soldToNumber" [disabled]="opt?.orderBlocked"
                    [ngClass]="opt?.orderBlocked ? 'bgGrey' : ''">
                    <span *ngIf="opt?.salesArea1"> {{ opt?.salesArea1 }}&nbsp;|&nbsp;</span>
                    <span *ngIf="opt?.salesArea2">{{opt?.salesArea2|cxTranslate}}</span>
                    <span *ngIf="opt?.salesArea3"> {{ opt?.salesArea3 }}</span>
                  </option>
                </select>
              </div>
              <div class="row">
                <div class="form-group col-xs-12 col-sm-12 col-lg-6">
                  <label for="date">{{'common.text_warranty_submit_date'|cxTranslate}}</label>
                  <input formControlName="date" class="form-control dateControl" placeholder="Datepicker" bsDatepicker
                    formControlName="date"
                    [bsConfig]="{ dateInputFormat: bsConfigFormat.toUpperCase(),showWeekNumbers:false, displayOneMonthRange: true }"
                    readOnly>
                  <app-error-message [control]="bAF.date"></app-error-message>
                </div>
                <div class="form-group col-xs-12 col-sm-12 col-lg-6">
                  <label>{{'common.text_ADB_applicationNum'|cxTranslate}}</label>
                  <div><input type="text" formControlName="applicationNum" class="form-control" readOnly></div>
                  <app-error-message [control]="bAF.applicationNum"></app-error-message>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-xs-12 col-sm-12 col-lg-6">
                  <label for="date">{{'common.profile_firstName'|cxTranslate}}</label>
                  <div><input formControlName="firstName" type="text" class="form-control" readOnly></div>
                  <app-error-message [control]="bAF.firstName"></app-error-message>
                </div>
                <div class="form-group col-xs-12 col-sm-12 col-lg-6">
                  <label>{{'common.adb_register_lastName'|cxTranslate}}</label>
                  <div><input formControlName="lastName" type="text" class="form-control" readOnly></div>
                  <app-error-message [control]="bAF.lastName"></app-error-message>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-xs-12 col-sm-12 col-lg-6">
                  <label for="date">{{'common.login_email'|cxTranslate}}</label>
                  <div><input formControlName="email" class="form-control" type="text"></div>
                  <app-error-message [control]="bAF.email"></app-error-message>
                </div>
                <div class="form-group col-xs-12 col-sm-12 col-lg-6">
                  <label>{{'common.text_ADB_register_company_phoneNumber'|cxTranslate}}</label>
                  <div><input formControlName="phone" class="form-control" type="text"></div>
                  <app-error-message [control]="bAF.phone"></app-error-message>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-xs-12 col-sm-12 col-lg-6">
                  <label for="date">{{'common.text_ADB_oem'|cxTranslate}}</label>
                  <div class="form-group select-box">

                    <select formControlName="oem" (change)="addDynamicfields()" class="form-control">
                      <option value="null" [selected]="bAF.oem == null">
                        {{'common.cart_orderType_selection'|cxTranslate}}</option>
                      <option [value]="item?.code" *ngFor="let item of  oEM">
                        {{item?.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.oem"></app-error-message>
                  </div>

                  <ng-container *ngIf="brakeApplicationForm.contains('oemBox')">
                    <input type="text" placeholder="Please Specify" formControlName="oemBox" class="form-control mt-3">
                    <ng-container
                      *ngIf="brakeApplicationForm.contains('oemBox') && brakeApplicationForm.get('oemBox').invalid && brakeApplicationForm.get('oemBox').touched ">
                      <div class="error-alert-msg other-input-error-msg">
                        <span class="text_danger_show_acc">
                          {{'common.form_field_required'|cxTranslate}}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
                <div class="form-group col-xs-12 col-sm-12 col-lg-6">
                  <label>{{'common.text_ADB_controlNumber'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" triggers="mouseenter:click"
                      [tooltip]="reqsampleTooltip" containerClass="customClass">
                      <img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #reqsampleTooltip>{{'common.text_ADB_controlNumber_internal_tooltext'|cxTranslate}}
                  </ng-template>
                  <div><input formControlName="controlNumber" class="form-control" type="text"></div>
                  <app-error-message [control]="bAF.controlNumber"></app-error-message>
                </div>
              </div>
            </div>
            <div class="levelofexperience ">
              <div class="leveltitle fsize_20 ml-3">
                <b>{{'common.myaccount_brakeform_levelofexp_text'|cxTranslate}}</b><button placement="bottom"
                  class="BAFtooltip" [tooltip]="levelofexpTooltip" containerClass="customClass"><img
                    src="/icons/question_dark_kb.svg"></button>
              </div>
              <ng-template #levelofexpTooltip>
                <span [innerHTML]="'common.myaccount_brakeform_levelofexp_tooltext'|cxTranslate"></span>
              </ng-template>
              <div class="checkboxTitle my-3 ml-3"> <b>{{'common.myaccount_brakeform_check_apply'|cxTranslate}}</b>
              </div>
              <div class="checkboxes" formArrayName="levelOfExp">
                <div [class.disable-after-submit]="submittedSuccessFully"
                  *ngFor="let control of levelOfExp.controls; let i = index">
                  <span>
                    <input (change)="checkBoxChecker()" type="checkbox" [formControlName]="i">
                    {{levelofExperience[i].name}}
                  </span>
                </div>
                <ng-container *ngIf="levelofExpError">
                  <div class="error-alert-msg">
                    <span class="text_danger_show_acc">
                      {{'common.form_field_required'|cxTranslate}}
                    </span>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="projectRequirements">
              <div class="fsize_24 mb-2 ml-1 project-req-title">
                <b>{{'common.myaccount_brakeform_projectreq_text'|cxTranslate}}</b>
              </div>
              <div class="leveltitle mb-2 fsize_20 ml-1">
                <b>{{'common.myaccount_brakeform_projecttarget_text'|cxTranslate}}</b><button placement="bottom"
                  class="BAFtooltip" [tooltip]="projreq1tooltip" containerClass="customClass"><img
                    src="/icons/question_dark_kb.svg"></button>
              </div>
              <ng-template
                #projreq1tooltip>{{'common.myaccount_brakeform_projecttarget_tooltext'|cxTranslate}}</ng-template>
              <div class="checkboxTitle"> <b>{{'common.myaccount_brakeform_check_apply'|cxTranslate}}</b></div>
              <div class="checkboxes" formArrayName="projectTarget">
                <div [class.disable-after-submit]="submittedSuccessFully"
                  *ngFor="let control of projectTgt.controls;let i = index">
                  <span><input type="checkbox" (change)="checkBoxChecker()" [formControlName]="i">
                    {{projectTargetContent[i].name}}</span>
                </div>
                <ng-container *ngIf="projecttargetError">
                  <div class="error-alert-msg">
                    <span class="text_danger_show_acc">
                      {{'common.form_field_required'|cxTranslate}}
                    </span>
                  </div>
                </ng-container>
              </div>
              <div class="radiobuttons checkbox-required-samples">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="formgroup">
                    <label for="">{{'common.myaccount_brakeform_required_sample_text'|cxTranslate}}
                      <button placement="bottom" class="BAFtooltip" [tooltip]="reqsampleTooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button>
                    </label>
                    <ng-template #reqsampleTooltip>{{'common.myaccount_brakeform_required_sample_tooltext'|cxTranslate}}
                    </ng-template>
                    <div class="radiocontainerDiv mb-2">
                      <div class="trueradioDiv">
                        <input type="radio" [formControlName]="'samplesRequired'" (change)="addDynamicfields()"
                          [value]="'true'"><span>{{'common.text_quote_yes_button_label'|cxTranslate}}</span>
                      </div>
                      <div class="falseradioDiv">
                        <input type="radio" [formControlName]="'samplesRequired'" (change)="addDynamicfields()"
                          [value]="'false'"><span>{{'common.text_warranty_submit_labourrequested_no'|cxTranslate}}</span>
                      </div>
                    </div>
                    <app-error-message [control]="bAF.samplesRequired"></app-error-message>
                    <ng-container *ngIf="brakeApplicationForm.contains('sampleANum')">
                      <div class="mt-2">
                        <label for="">{{'common.myaccount_brakeform_required_sampleA_text'|cxTranslate}}
                          <button placement="bottom" class="BAFtooltip" [tooltip]="reqsampleTooltip"
                            containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button>
                        </label>
                        <ng-template
                          #reqsampleTooltip>{{'common.myaccount_brakeform_required_sampleA_tooltext'|cxTranslate}}
                        </ng-template>
                        <div>
                          <input class="mt-2" type="text" formControlName="sampleANum" placeholder="Please Specify"
                            class="form-control">
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="formgroup">
                    <label for="">{{'common.myaccount_brakeform_targetdate_text'|cxTranslate}} <button
                        placement="bottom" class="BAFtooltip" [tooltip]="targetDelDateTooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button>
                    </label>
                    <ng-template
                      #targetDelDateTooltip>{{'common.myaccount_brakeform_targetdate_text_tooltext'|cxTranslate}}</ng-template>
                    <div class="radiocontainerDiv mb-2">
                      <div class="trueradioDiv">
                        <input type="radio" [formControlName]="'targetDateAvailable'" (change)="addDynamicfields()"
                          [value]="'true'"><span>{{'common.text_quote_yes_button_label'|cxTranslate}}</span>
                      </div>
                      <div class="falseradioDiv">
                        <input type="radio" [formControlName]="'targetDateAvailable'" (change)="addDynamicfields()"
                          [value]="'false'"><span>{{'common.text_warranty_submit_labourrequested_no'|cxTranslate}}</span>
                      </div>
                    </div>
                    <app-error-message [control]="bAF.targetDateAvailable"></app-error-message>
                    <ng-container *ngIf="brakeApplicationForm.contains('sampleADate')">
                      <div class="mt-2">
                        <label for="">{{'common.myaccount_brakeform_targetdate_sampleA_text'|cxTranslate}}*
                          <button placement="bottom" class="BAFtooltip" [tooltip]="reqsampleTooltip"
                            containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button>
                        </label>
                        <ng-template
                          #reqsampleTooltip>{{'common.myaccount_brakeform_targetdate_sampleA_tooltext'|cxTranslate}}
                        </ng-template>
                        <div>
                          <input formControlName="sampleADate" bsDatepicker [minDate]="today"
                            [bsConfig]="{ dateInputFormat: bsConfigFormat.toUpperCase() ,showWeekNumbers:false, displayOneMonthRange: true }"
                            placeholder={{bsConfigFormat.toLowerCase()}}
                            class="form-control  bsdpicker kb-datePickerIcon mt-2">
                          <ng-container
                            *ngIf="brakeApplicationForm.contains('sampleADate') && brakeApplicationForm.get('sampleADate').invalid && brakeApplicationForm.get('sampleADate').touched ">
                            <div>
                              <span class="text_danger_show_acc">
                                {{'common.form_field_required'|cxTranslate}}
                              </span>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="row col-12 px-0 mx-0">
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <label for="customerDate">{{'common.myaccount_brakeform_sop_targetdate_text'|cxTranslate}}
                      <button placement="bottom" class="BAFtooltip" [tooltip]="targetDatetooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button>
                    </label>
                    <ng-template
                      #targetDatetooltip>{{'common.myaccount_brakeform_sop_targetdate_tooltext'|cxTranslate}}</ng-template>
                    <input formControlName="productionStartDate" bsDatepicker [minDate]="today"
                      [bsConfig]="{ dateInputFormat: bsConfigFormat.toUpperCase(),showWeekNumbers:false, displayOneMonthRange: true }"
                      placeholder={{bsConfigFormat.toLowerCase()}} class="form-control  bsdpicker kb-datePickerIcon">
                    <app-error-message [control]="bAF.productionStartDate"></app-error-message>
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <label for="">{{'common.myaccount_brakeform_ppv_firstyear_text'|cxTranslate}}</label>
                    <input type="text" class="form-control" formControlName="firstYearVol"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    <app-error-message [control]="bAF.firstYearVol"></app-error-message>
                  </div>
                </div>
                <div class="row col-12 px-0 mx-0">
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <label for="">{{'common.myaccount_brakeform_ppv_secondyear_text'|cxTranslate}}</label>
                    <input formControlName="secondYearVol" class="form-control" type="text"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    <app-error-message [control]="bAF.secondYearVol"></app-error-message>
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <label for="">{{'common.myaccount_brakeform_ppv_thirdyear_text'|cxTranslate}}</label>
                    <input formControlName="thirdYearVol" class="form-control" type="text"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    <app-error-message [control]="bAF.thirdYearVol"></app-error-message>
                  </div>
                </div>
                <div class="row col-12 px-0 mx-0">
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <label for="">{{'common.myaccount_brakeform_end_user_text'|cxTranslate}}
                      <button placement="bottom" class="BAFtooltip" [tooltip]="endusertooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button>
                    </label>
                    <ng-template
                      #endusertooltip>{{'common.myaccount_brakeform_end_user_tooltext'|cxTranslate}}</ng-template>
                    <div><input formControlName="endUser" type="text"
                        [placeholder]="'common.text_adb_placeholder'|cxTranslate"></div>
                    <app-error-message [control]="bAF.endUser"></app-error-message>
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <label class="add" [class.customWidth]="customWidth"
                      for="">{{'common.myaccount_brakeform_conduct_fields_text'|cxTranslate}}
                      <button placement="bottom" class="BAFtooltip" [tooltip]="fieldtestConducttooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button>
                    </label>
                    <ng-template
                      #fieldtestConducttooltip>{{'common.myaccount_brakeform_conduct_fields_tooltext'|cxTranslate}}</ng-template>
                    <div class="form-group select-box">
                      <select formControlName="ftPlanned" (change)="addDynamicfields()" class="form-control">
                        <option value="null">{{'common.form_select_empty'|cxTranslate}}</option>
                        <option [value]="item.code" *ngFor=" let item of fieldTestPlanned">{{item.name}}</option>
                      </select>
                      <app-error-message [control]="bAF.ftPlanned"></app-error-message>
                    </div>
                  </div>
                </div>
                <div class="row col-12 px-0 mx-0">
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <label for="">{{'common.myaccount_brakeform_vehicles_used_text'|cxTranslate}}</label>
                    <input formControlName="ftVehicleCount" class="form-control" type="text"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    <app-error-message [control]="bAF.ftVehicleCount"></app-error-message>
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <label for="">{{'common.myaccount_brakeform_field_test_text'|cxTranslate}}<button placement="bottom"
                        class="BAFtooltip" [tooltip]="PerformedFieldTesttooltip" containerClass="customClass"><img
                          src="/icons/question_dark_kb.svg"></button></label>
                    <ng-template
                      #PerformedFieldTesttooltip>{{'common.myaccount_brakeform_field_test_tooltext'|cxTranslate}}</ng-template>
                    <input formControlName="ftDetails" class="form-control" type="text"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    <app-error-message [control]="bAF.ftDetails"></app-error-message>
                  </div>
                </div>
              </div>
              <div class="row col-xs-12 col-sm-12 c0l-md-6">
                <div class="formgroup">
                  <label for="radiobutton">{{'common.myaccount_brakeform_legal_requirement_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="vehOptooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button></label>
                  <ng-template #vehOptooltip> <span
                      [innerHTML]="'common.myaccount_brakeform_legal_requirement_tooltext'|cxTranslate"></span></ng-template>
                  <div class="radiocontainerDiv mb-2">
                    <div class="trueradioDiv">
                      <input type="radio" [formControlName]="'vehicleOperationalOutside'" (change)="addDynamicfields()"
                        [value]="'true'"><span>{{'common.text_quote_yes_button_label'|cxTranslate}}</span>
                    </div>
                    <div class="falseradioDiv">
                      <input type="radio" [formControlName]="'vehicleOperationalOutside'" (change)="addDynamicfields()"
                        [value]="'false'"><span>{{'common.text_warranty_submit_labourrequested_no'|cxTranslate}}</span>
                    </div>
                  </div>
                  <ng-container *ngIf="brakeApplicationForm.contains('vehicleOperationalOutsideText')">
                    <input type="text" formControlName="vehicleOperationalOutsideText" placeholder="Please Specify"
                      class="form-control mt-3 mb-2">
                    <ng-container
                      *ngIf="brakeApplicationForm.contains('vehicleOperationalOutsideText') && brakeApplicationForm.get('vehicleOperationalOutsideText').invalid && brakeApplicationForm.get('vehicleOperationalOutsideText').touched ">
                      <div>
                        <span class="text_danger_show_acc">
                          {{'common.form_field_required'|cxTranslate}}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_cad_model_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="threeDtooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #threeDtooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_cad_model_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="cadModelAvailability" class="form-control">
                      <option value="null" [selected]="bAF.cadModelAvailability.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of three3DCAD">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.cadModelAvailability"></app-error-message>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_painting_condition_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="paintingConditiontooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #paintingConditiontooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_painting_condition_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input formControlName="paintingCondition" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.paintingCondition"></app-error-message>
                </div>
              </div>
            </div>
            <div class="vehicleInfoGeneral">
              <div class=" fsize_24 mb-2 vehicleTitle">
                <b>{{'common.myaccount_brakeform_vehicle_genral_tooltex'|cxTranslate}}</b>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                  <label for="">
                    {{'common.vehicleModel_code_value'|cxTranslate}}
                  </label>
                  <div class="form-group  select-box">
                    <select formControlName="vehicleModel" (change)="addDynamicfields()" class="form-control">
                      <option value="null" [selected]="bAF.vehicleModel.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of vehicleModel">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.vehicleModel"></app-error-message>
                  </div>
                  <ng-container *ngIf="brakeApplicationForm.contains('vehicleModelMsg')">
                    <input type="text" formControlName="vehicleModelMsg" placeholder="Please Specify"
                      class="form-control mt-3">
                    <ng-container
                      *ngIf="brakeApplicationForm.contains('vehicleModelMsg') && brakeApplicationForm.get('vehicleModelMsg').invalid && brakeApplicationForm.get('vehicleModelMsg').touched ">
                      <div>
                        <span class="text_danger_show_acc">
                          {{'common.form_field_required'|cxTranslate}}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                  <label for="">
                    {{'common.text_ADB_chassisNumber'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" containerClass="customClass" [tooltip]="chasisNo">
                      <img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #chasisNo><span
                      [innerHTML]="'common.text_ADB_chassisNumber_tooltext'|cxTranslate"></span></ng-template>
                  <div>
                    <input formControlName="chassisNumber" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.chassisNumber"></app-error-message>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                  <label for="">
                    {{'common.text_ADB_vehicleType'|cxTranslate}}

                  </label>
                  <div class="form-group  select-box">
                    <select formControlName="vehicleType" (change)="addDynamicfields()" class="form-control">
                      <option value="null" [selected]="bAF.vehicleType.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of vehicleType">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.vehicleType"></app-error-message>
                  </div>
                  <ng-container *ngIf="brakeApplicationForm.contains('vehicleTypeBox')">
                    <input type="text" placeholder="Please Specify" formControlName="vehicleTypeBox"
                      class="form-control mt-3">
                    <ng-container
                      *ngIf="brakeApplicationForm.contains('vehicleTypeBox') && brakeApplicationForm.get('vehicleTypeBox').invalid && brakeApplicationForm.get('vehicleTypeBox').touched ">
                      <div>
                        <span class="text_danger_show_acc">
                          {{'common.form_field_required'|cxTranslate}}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                  <label for="">
                    {{'common.myaccount_brakeform_Chassis_modification_text'|cxTranslate}}
                    <button [tooltip]="chasisModificationTooltext" placement="bottom" class="BAFtooltip"
                      containerClass="customClass">
                      <img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #chasisModificationTooltext><span
                      [innerHTML]="'common.myaccount_brakeform_Chassis_modification_tooltext'|cxTranslate"></span></ng-template>
                  <div>
                    <input formControlName="chassisModification" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.chassisModification"></app-error-message>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                  <label for="">
                    {{'common.text_ADB_vocation'|cxTranslate}}

                  </label>
                  <div class="form-group select-box ">
                    <select formControlName="vocation" (change)="addDynamicfields()" class="form-control">
                      <option value="null" [selected]="bAF.vocation.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of vocation">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.vocation"></app-error-message>
                  </div>

                  <ng-container *ngIf="brakeApplicationForm.contains('vocationBox')">
                    <input type="text" placeholder="Please Specify" formControlName="vocationBox"
                      class="form-control mt-3">
                    <ng-container
                      *ngIf="brakeApplicationForm.contains('vocationBox') && brakeApplicationForm.get('vocationBox').invalid && brakeApplicationForm.get('vocationBox').touched ">
                      <div>
                        <span class="text_danger_show_acc">
                          {{'common.form_field_required'|cxTranslate}}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                  <label for="">
                    {{'common.myaccount_brakeform_Vehicle_lifetime_text'|cxTranslate}}
                    <button [tooltip]="lifeTimetoolText" placement="bottom" class="BAFtooltip"
                      containerClass="customClass">
                      <img src="/icons/question_dark_kb.svg" alt="Break Application Forms"></button>
                  </label>
                  <ng-template #lifeTimetoolText><span
                      [innerHTML]="'common.myaccount_brakeform_Vehicle_lifetime_tooltext'|cxTranslate"></span></ng-template>
                  <div>
                    <input formControlName="vehicleLifetime" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.vehicleLifetime"></app-error-message>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <label for="">
                    {{'common.myaccount_brakeform_annual_use_text'|cxTranslate}}
                    <button [tooltip]="annualUseToolText" placement="bottom" class="BAFtooltip"
                      containerClass="customClass">
                      <img src="/icons/question_dark_kb.svg" alt="Break Application Forms"></button>
                  </label>
                  <ng-template #annualUseToolText><span
                      [innerHTML]="'common.myaccount_brakeform_annual_use_tooltext'|cxTranslate"></span></ng-template>
                  <div>
                    <input formControlName="annualUsage" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.annualUsage"></app-error-message>
                </div>
                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <label for="">
                    {{'common.myaccount_brakeform_highway_operation_text'|cxTranslate}}
                    <button [tooltip]="highWayOperationToolText" placement="bottom" class="BAFtooltip"
                      containerClass="customClass">
                      <img src="/icons/question_dark_kb.svg" alt="Break Application Forms"></button>
                  </label>
                  <ng-template #highWayOperationToolText><span
                      [innerHTML]="'common.myaccount_brakeform_highway_operation_tooltext'|cxTranslate"></span></ng-template>
                  <div>
                    <input formControlName="onHighwayUsage" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.onHighwayUsage"></app-error-message>
                </div>
              </div>
            </div>
            <div class="endurancesection">
              <div class="checkboxTitle my-3">
                {{'common.myaccount_brakeform_endurance_brake_text'|cxTranslate}}&nbsp; -
                <b>{{'common.myaccount_brakeform_check_apply'|cxTranslate}}</b><button placement="bottom"
                  class="BAFtooltip" [tooltip]="endurancetooltip" containerClass="customClass"><img
                    src="/icons/question_dark_kb.svg"></button>
              </div>
              <ng-template
                #endurancetooltip>{{'common.myaccount_brakeform_endurance_brake_tooltext'|cxTranslate}}</ng-template>
              <div class="checkboxes" formArrayName="enduranceBreakSys">
                <div [class.disable-after-submit]="submittedSuccessFully"
                  *ngFor="let control of endBrkSys.controls;let i = index">
                  <span>
                    <input type="checkbox" (change)="checkBoxChecker()"
                      [formControlName]="i">{{EnduranceBrakeSystem[i].name}}
                  </span>
                </div>
                <ng-container *ngIf="endurancebrakeSyserror">
                  <div class="error-alert-msg">
                    <span class="text_danger_show_acc">
                      {{'common.form_field_required'|cxTranslate}}
                    </span>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="enduranceFormSection">
              <div class="row col-12 px-0 mx-0">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label class="add" [class.customWidth]="customWidth"
                    for="3dcad">{{'common.myaccount_brakeform_maximum_optimum_grade_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="optgradetooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #optgradetooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_maximum_optimum_grade_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input type="text" formControlName="maximumOptimumGrade" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group Align_In_A_Row ">
                  <label for="3dcad">{{'common.myaccount_brakeform_service_brake_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="serviceBrakeDuty"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #serviceBrakeDuty>
                    <span [innerHTML]="'common.myaccount_brakeform_service_brake_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input type="text" formControlName="serviceBrakeDutyCycle" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.serviceBrakeDutyCycle"></app-error-message>
                </div>
              </div>
              <div class="row col-12 px-0 mx-0">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group Align_In_A_Row">
                  <label for="3dcad">{{'common.myaccount_brakeform_parking_duty_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="parkingtooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #parkingtooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_parking_duty_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input formControlName="parkingDutyCycle" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.parkingDutyCycle"></app-error-message>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_required_NVH_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="nvhtooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #nvhtooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_required_NVH_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input formControlName="nvhRequirements" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.nvhRequirements"></app-error-message>
                </div>
              </div>
              <div class="radioButtons">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="formgroup">
                    <label for="">{{'common.myaccount_brakeform_parking_test_text'|cxTranslate}}
                      <button placement="bottom" class="BAFtooltip" [tooltip]="parkTestTooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button>
                    </label>
                    <ng-template
                      #parkTestTooltip>{{'common.myaccount_brakeform_parking_test_tooltext'|cxTranslate}}</ng-template>
                    <div class="radiocontainerDiv mb-2">
                      <div class="trueradioDiv">
                        <input type="radio" [formControlName]="'endUserPTReq'" (change)="addDynamicfields()"
                          [value]="'true'"><span>{{'common.text_quote_yes_button_label'|cxTranslate}}</span>
                      </div>
                      <div class="falseradioDiv">
                        <input type="radio" [formControlName]="'endUserPTReq'" (change)="addDynamicfields()"
                          [value]="'false'"><span>{{'common.text_warranty_submit_labourrequested_no'|cxTranslate}}</span>
                      </div>
                    </div>
                    <app-error-message [control]="bAF.endUserPTReq"></app-error-message>
                    <ng-container *ngIf="brakeApplicationForm.contains('endUserPTBox')">
                      <input class="mt-2" placeholder="Please Specify" type="text" formControlName="endUserPTBox"
                        class="form-control">
                      <ng-container
                        *ngIf="brakeApplicationForm.contains('endUserPTBox') && brakeApplicationForm.get('endUserPTBox').invalid && brakeApplicationForm.get('endUserPTBox').touched ">
                        <div>
                          <span class="text_danger_show_acc">
                            {{'common.form_field_required'|cxTranslate}}
                          </span>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="formgroup">
                    <label for="">{{'common.myaccount_brakeform_pneumatic_system_text'|cxTranslate}}
                      <button placement="bottom" class="BAFtooltip" [tooltip]="pneumaticTooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button>
                    </label>
                    <ng-template
                      #pneumaticTooltip>{{'common.myaccount_brakeform_pneumatic_system_tooltext'|cxTranslate}}</ng-template>
                    <div class="form-group select-box">
                      <select formControlName="pneumaticSystem" class="form-control">
                        <option value="null" [selected]="bAF.pneumaticSystem.value == null">
                          {{'common.form_select_empty'|cxTranslate}}</option>
                        <option [value]="item.code" *ngFor="let item of pneumatic">{{item.name}}</option>
                      </select>
                      <app-error-message [control]="bAF.pneumaticSystem"></app-error-message>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="formgroup">
                    <label for="">{{'common.myaccount_brakeform_brake_equipped_text'|cxTranslate}}
                      <button placement="bottom" class="BAFtooltip" [tooltip]="brakeequipTooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button>
                    </label>
                    <ng-template
                      #brakeequipTooltip>{{'common.myaccount_brakeform_brake_equipped_tooltext'|cxTranslate}}</ng-template>
                    <div class="radiocontainerDiv mb-2">
                      <div class="trueradioDiv">
                        <input type="radio" [formControlName]="'brakeEquippeds'" (change)="addDynamicfields()"
                          [value]="'true'"><span>{{'common.text_quote_yes_button_label'|cxTranslate}}</span>
                      </div>
                      <div class="falseradioDiv">
                        <input type="radio" [formControlName]="'brakeEquippeds'" (change)="addDynamicfields()"
                          [value]="'false'"><span>{{'common.text_warranty_submit_labourrequested_no'|cxTranslate}}</span>
                      </div>
                    </div>
                    <app-error-message [control]="bAF.brakeEquippeds"></app-error-message>
                    <ng-container *ngIf="brakeApplicationForm.contains('brakeEquippedsBox')">
                      <input class="mt-2 form-control" placeholder="Please Specify" type="text"
                        formControlName="brakeEquippedsBox">
                      <ng-container
                        *ngIf="brakeApplicationForm.contains('brakeEquippedsBox') && brakeApplicationForm.get('brakeEquippedsBox').invalid && brakeApplicationForm.get('brakeEquippedsBox').touched ">
                        <div>
                          <span class="text_danger_show_acc">
                            {{'common.form_field_required'|cxTranslate}}
                          </span>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="parkingTestRequirements">
                <div class="checkboxTitle my-3">
                  {{'common.myaccount_brakeform_parking_test_oem_text'|cxTranslate}} -
                  <b>{{'common.myaccount_brakeform_check_apply'|cxTranslate}}</b><button placement="bottom"
                    class="BAFtooltip" [tooltip]="parktestOemtooltip" containerClass="customClass"><img
                      src="/icons/question_dark_kb.svg"></button>
                </div>
                <ng-template
                  #parktestOemtooltip>{{'common.myaccount_brakeform_parking_test_oem_tooltext'|cxTranslate}}</ng-template>
                <div class="checkboxes" formArrayName="oemPTReq">
                  <div [class.disable-after-submit]="submittedSuccessFully"
                    *ngFor="let control of oemptreq.controls;let i = index">
                    <span>
                      <input (change)="addDynamicfields()" type="checkbox"
                        [formControlName]="i">{{oemPTReqContent[i].name}}
                    </span>
                  </div>
                </div>
                <ng-container *ngIf="parkingTestRequirementsError">
                  <div class="error-alert-msg">
                    <span class="text_danger_show_acc">
                      {{'common.form_field_required'|cxTranslate}}
                    </span>
                  </div>
                </ng-container>
                <ng-container *ngIf="brakeApplicationForm?.contains('oemPTReqBox')">
                  <div class="col-xs-12 col-sm-12 col-lg-6 pl-3">
                    <input class="mt-3" type="text" placeholder="Please Specify" formControlName="oemPTReqBox"
                      class="form-control">
                  </div>
                  <ng-container
                    *ngIf="brakeApplicationForm?.contains('oemPTReqBox') && brakeApplicationForm?.get('oemPTReqBox').invalid && brakeApplicationForm?.get('oemPTReqBox').touched ">
                    <div class="col-xs-12 col-sm-12 col-lg-6 pl-3">
                      <span class="text_danger_show_acc">
                        {{'common.form_field_required'|cxTranslate}}
                      </span>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
              <div class="vehicleopenv">
                <div class="checkboxTitle my-3">
                  {{'common.myaccount_brakeform_Vehicle_Operating_text'|cxTranslate}} -
                  <b>{{'common.myaccount_brakeform_check_apply'|cxTranslate}}</b><button placement="bottom"
                    class="BAFtooltip" [tooltip]="vehopttesttooltip" containerClass="customClass"><img
                      src="/icons/question_dark_kb.svg"></button>
                </div>
                <ng-template
                  #vehopttesttooltip>{{'common.myaccount_brakeform_Vehicle_Operating_tooltext'|cxTranslate}}</ng-template>
                <div class="checkboxes" formArrayName="vehicleOEC">
                  <div [class.disable-after-submit]="submittedSuccessFully"
                    *ngFor="let control of vehicleoec.controls; let i = index"><span><input type="checkbox"
                        [formControlName]="i">{{vehicleOECContent[i].name}}</span></div>
                </div>
              </div>
              <div class="vehicleInfoFinalFormSection col-12">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                    <label for="3dcad">{{'common.text_ADB_brakeType'|cxTranslate}}
                      <button placement="bottom" class="BAFtooltip" [tooltip]="brktyptooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                          alt="Break Application Forms">
                      </button>
                    </label>
                    <ng-template #brktyptooltip>
                      <span [innerHTML]="'common.myaccount_brakeform_brake_type_tooltext'|cxTranslate"></span>
                    </ng-template>
                    <div class="form-group select-box">
                      <select formControlName="brakeType" class="form-control">
                        <option value="null" [selected]="bAF.brakeType.value == null">
                          {{'common.form_select_empty'|cxTranslate}}</option>
                        <option [value]="item.code" *ngFor="let item of brakeType">{{item.name}}</option>
                      </select>
                      <app-error-message [control]="bAF.brakeType"></app-error-message>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                    <label for="3dcad">{{'common.text_ADB_axleConfig'|cxTranslate}}
                      <button placement="bottom" class="BAFtooltip" [tooltip]="axleconfigtooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                          alt="Break Application Forms">
                      </button>
                    </label>
                    <ng-template #axleconfigtooltip>
                      <span [innerHTML]="'common.myaccount_brakeform_axle_config_tooltext'|cxTranslate"></span>
                    </ng-template>
                    <div>
                      <input formControlName="axleConfig" type="text" class="form-control"
                        [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    </div>
                    <app-error-message [control]="bAF.axleConfig"></app-error-message>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                    <label for="3dcad">{{'common.myaccount_brakeform_abs_sensor_count_text'|cxTranslate}}
                      <button placement="bottom" class="BAFtooltip" [tooltip]="absmodtooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                          alt="Break Application Forms">
                      </button>
                    </label>
                    <ng-template #absmodtooltip>
                      <span [innerHTML]="'common.myaccount_brakeform_abs_sensor_count_text'|cxTranslate"></span>
                    </ng-template>
                    <div>
                      <input type="text" formControlName="absSensorCount" class="form-control"
                        [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    </div>
                    <app-error-message [control]="bAF.absSensorCount"></app-error-message>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                    <label for="3dcad">{{'common.myaccount_brakeform_abs_modular_count_text'|cxTranslate}}
                      <button placement="bottom" class="BAFtooltip" [tooltip]="absModulatortooltip"
                        containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                          alt="Break Application Forms">
                      </button>
                    </label>
                    <ng-template #absModulatortooltip>
                      <span [innerHTML]="'common.myaccount_brakeform_abs_modular_count_tooltext'|cxTranslate"></span>
                    </ng-template>
                    <div>
                      <input formControlName="absModulatorCount" type="text" class="form-control"
                        [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    </div>
                    <app-error-message [control]="bAF.absModulatorCount"></app-error-message>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                    <label for="3dcad">{{'common.myaccount_brakeform_GVWR_lbs_text'|cxTranslate}}
                    </label>
                    <div>
                      <input formControlName="gvwr" type="text" class="form-control"
                        [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    </div>
                    <app-error-message [control]="bAF.gvwr"></app-error-message>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                    <label for="3dcad">{{'common.myaccount_brakeform_wheelbase_range_text'|cxTranslate}}
                    </label>
                    <div>
                      <input formControlName="wheelBaseRange" type="text" class="form-control"
                        [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    </div>
                    <app-error-message [control]="bAF.wheelBaseRange"></app-error-message>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                    <label for="3dcad">{{'common.myaccount_brakeform_cog_height_laden_text'|cxTranslate}}
                    </label>
                    <div>
                      <input formControlName="cgHeightLaden" type="text" class="form-control"
                        [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    </div>
                    <app-error-message [control]="bAF.cgHeightLaden"></app-error-message>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                    <label for="3dcad">{{'common.myaccount_brakeform_cog_height_unladen_text'|cxTranslate}}
                    </label>
                    <div>
                      <input formControlName="cgHeightUnladen" type="text" class="form-control"
                        [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    </div>
                    <app-error-message [control]="bAF.cgHeightUnladen"></app-error-message>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="axleInformation">
            <div class="vehicleAxleInfotitle mb-2 fsize_24">
              <b>{{'common.myaccount_brakeform_vehicle_info_text'|cxTranslate}}</b>
            </div>
            <div class="steerAxle fsize_20 mb-2"><b>{{'common.myaacount_brakeform_steer_text'|cxTranslate}}</b>
            </div>
            <div class="steerAxleFormSection">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_axle_manu_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="axlmanufacttooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #axlmanufacttooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_axle_manu_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="steerAxleManu" (change)="addDynamicfields()" class="form-control">
                      <option value="null" [selected]="bAF.steerAxleManu.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of axleManufacturer">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.steerAxleManu"></app-error-message>
                  </div>
                  <ng-container *ngIf="brakeApplicationForm.contains('steerAxleManuBox')">
                    <input type="text" placeholder="Please Specify" formControlName="steerAxleManuBox"
                      class="form-control mt-3">
                    <ng-container
                      *ngIf="brakeApplicationForm.contains('steerAxleManuBox') && brakeApplicationForm.get('steerAxleManuBox').invalid && brakeApplicationForm.get('steerAxleManuBox').touched ">
                      <div>
                        <span class="text_danger_show_acc">
                          {{'common.form_field_required'|cxTranslate}}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_brake_assembly_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="partyperformingBraketooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #partyperformingBraketooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_brake_assembly_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="steerAxleBAIP" class="form-control">
                      <option value="null" [selected]="bAF.steerAxleBAIP.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of partPerforming">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.steerAxleBAIP"></app-error-message>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_axle_design_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="axldesigntooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #axldesigntooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_axle_design_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="steerAxleStatus" class="form-control">
                      <option value="null" [selected]="bAF.steerAxleStatus.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of axleDesign">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.steerAxleStatus"></app-error-message>
                  </div>

                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_axle_toc_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="typeofconnectiontoaxleflangetooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #typeofconnectiontoaxleflangetooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_axle_toc_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="steerAxleTOC" (change)="addDynamicfields()" class="form-control">
                      <option value="null" [selected]="bAF.steerAxleTOC.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of tOCAxleFlange">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.steerAxleTOC"></app-error-message>
                  </div>
                  <ng-container *ngIf="brakeApplicationForm.contains('steerAxleTOCBox')">
                    <input type="text" placeholder="Please Specify" formControlName="steerAxleTOCBox"
                      class="form-control mt-3">
                    <ng-container
                      *ngIf="brakeApplicationForm.contains('steerAxleTOCBox') && brakeApplicationForm.get('steerAxleTOCBox').invalid && brakeApplicationForm.get('steerAxleTOCBox').touched ">
                      <div>
                        <span class="text_danger_show_acc">
                          {{'common.form_field_required'|cxTranslate}}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
              <div class=" row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_brake_disc_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="rotortooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #rotortooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_brake_disc_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input formControlName="steerAxleBrakeDiscInfo" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.steerAxleBrakeDiscInfo"></app-error-message>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_actuator_intended_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="actuatortooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #actuatortooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_act_intended_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input formControlName="steerAxleBrakeActInfo" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.steerAxleBrakeActInfo"></app-error-message>
                </div>
              </div>
              <div class=" row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_vcp_text'|cxTranslate}}</label>
                  <div>
                    <input type="text" formControlName="steerAxleValveCP" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.steerAxleBrakeActInfo"></app-error-message>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-xs-12 col-sm-12 col-lg-6">
                  <label for="">{{'common.myaccount_brakeform_steer_axle_text'|cxTranslate}}</label>
                  <div class="radiocontainerDiv mb-2">
                    <div class="trueradioDiv">
                      <input type="radio" [formControlName]="'steerAxleDriven'" (change)="addDynamicfields()"
                        [value]="'true'"><span>{{'common.text_quote_yes_button_label'|cxTranslate}}</span>
                    </div>
                    <div class="falseradioDiv">
                      <input type="radio" [formControlName]="'steerAxleDriven'" (change)="addDynamicfields()"
                        [value]="'false'"><span>{{'common.text_warranty_submit_labourrequested_no'|cxTranslate}}</span>
                    </div>
                  </div>
                  <app-error-message [control]="bAF.steerAxleDriven"></app-error-message>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_steer_axletype_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="axltypertooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #axltypertooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_steer_axletype_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="steerAxleType" class="form-control">
                      <option value="null" [selected]="bAF.steerAxleType.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of axleType">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.steerAxleType"></app-error-message>
                  </div>
                </div>
              </div>
              <div class=" row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label class="add" [class.customWidth]="customWidth"
                    for="3dcad">{{'common.myaccount_brakeform_desired_parking_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="intendedparktooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #intendedparktooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_desired_parking_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="steerAxleParking" class="form-control">
                      <option value="null" [selected]="bAF.steerAxleParking.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of intendedOrDesigned">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.steerAxleParking"></app-error-message>
                  </div>

                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_GAWR_lbs_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="grossAxletooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #grossAxletooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_GAWR_lbs_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input formControlName="steerAxleGAWR" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    <app-error-message [control]="bAF.steerAxleGAWR"></app-error-message>
                  </div>

                </div>
              </div>
              <div class=" row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_axle_weight_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="custaxlweighttooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #custaxlweighttooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_axle_weight_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input formControlName="steerAxleWeightLimit" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.steerAxleWeightLimit"></app-error-message>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_wheel_rimsize_text'|cxTranslate}}
                  </label>
                  <div>
                    <input formControlName="steerAxleWheelRimSize" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    <app-error-message [control]="bAF.steerAxleWheelRimSize"></app-error-message>
                  </div>
                </div>
              </div>
              <div class=" row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_tire_type_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="indicatetyretypeparktooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #indicatetyretypeparktooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_tire_type_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="steerAxleTireType" class="form-control">
                      <option value="null" [selected]="bAF.steerAxleTireType.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of tireType">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.steerAxleTireType"></app-error-message>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_tire_static_text'|cxTranslate}}</label>
                  <div>
                    <input formControlName="steerAxleSLR" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                    <app-error-message [control]="bAF.steerAxleSLR"></app-error-message>
                  </div>
                </div>
              </div>
              <div class=" row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_proposed_brake_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="custBraketooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #custBraketooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_proposed_brake_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input formControlName="steerAxleCustPropBrake" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.steerAxleCustPropBrake"></app-error-message>
                </div>
              </div>
            </div>
            <div class="driveAxle mb-2"><b class="fsize_20">{{'common.myaacount_brakeform_drive_text'|cxTranslate}}</b>
            </div>
            <div class="driveAxleFormSection">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_axle_manu_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="axlmanufacttooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #axlmanufacttooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_axle_manu_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="driveAxleManu" class="form-control" (change)="addDynamicfields()">
                      <option value="null" [selected]="bAF.driveAxleManu.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of axleManufacturer">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.driveAxleManu"></app-error-message>
                  </div>
                  <ng-container *ngIf="brakeApplicationForm.contains('driveAxleManuBox')">
                    <input type="text" placeholder="Please Specify" formControlName="driveAxleManuBox"
                      class="form-control mt-3">
                    <ng-container
                      *ngIf="brakeApplicationForm.contains('driveAxleManuBox') && brakeApplicationForm.get('driveAxleManuBox').invalid && brakeApplicationForm.get('driveAxleManuBox').touched ">
                      <div>
                        <span class="text_danger_show_acc">
                          {{'common.form_field_required'|cxTranslate}}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_brake_assembly_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="partyperformingBraketooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #partyperformingBraketooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_brake_assembly_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="driveAxleBAIP" class="form-control">
                      <option value="null" [selected]="bAF.driveAxleBAIP.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of partPerforming">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.driveAxleBAIP"></app-error-message>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_axle_design_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="axldesigntooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #axldesigntooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_axle_design_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="driveAxleStatus" class="form-control">
                      <option value="null" [selected]="bAF.driveAxleStatus.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of axleDesign">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.driveAxleStatus"></app-error-message>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_axle_toc_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="typeofconntooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #typeofconntooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_axle_toc_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="driveAxleTOC" (change)="addDynamicfields()" class="form-control">
                      <option value="null" [selected]="bAF.driveAxleTOC.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of tOCAxleFlange">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.driveAxleTOC"></app-error-message>
                  </div>
                  <ng-container *ngIf="brakeApplicationForm.contains('driveAxleTOCBox')">
                    <input type="text" placeholder="Please Specify" formControlName="driveAxleTOCBox"
                      class="form-control mt-3">
                    <ng-container
                      *ngIf="brakeApplicationForm.contains('driveAxleTOCBox') && brakeApplicationForm.get('driveAxleTOCBox').invalid && brakeApplicationForm.get('driveAxleTOCBox').touched ">
                      <div>
                        <span class="text_danger_show_acc">
                          {{'common.form_field_required'|cxTranslate}}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_brake_disc_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="rotortooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #rotortooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_brake_disc_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input formControlName="driveAxleBrakeDiscInfo" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.driveAxleBrakeDiscInfo"></app-error-message>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_actuator_intended_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="actuatortooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #actuatortooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_act_intended_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input formControlName="driveAxleBrakeActInfo" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.driveAxleBrakeActInfo"></app-error-message>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_vcp_text'|cxTranslate}}</label>
                  <div>
                    <input formControlName="driveAxleValveCP" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.driveAxleValveCP"></app-error-message>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_steer_axletype_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="axltypertooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #axltypertooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_steer_axletype_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="driveAxleType" class="form-control">
                      <option value="null" [selected]="bAF.driveAxleType.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of axleType">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.driveAxleType"></app-error-message>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label class="add" [class.customWidth]="customWidth"
                    for="3dcad">{{'common.myaccount_brakeform_desired_parking_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="intendedparktooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #intendedparktooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_desired_parking_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="driveAxleParking" class="form-control">
                      <option value="null" [selected]="bAF.driveAxleParking.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of intendedOrDesigned">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.driveAxleParking"></app-error-message>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_axle_weight_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="custaxlweighttooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #custaxlweighttooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_axle_weight_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group">
                    <input formControlName="driveAxleWeightLimit" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.driveAxleWeightLimit"></app-error-message>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_GAWR_lbs_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="grossAxletooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #grossAxletooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_GAWR_lbs_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group">
                    <input formControlName="driveAxleGAWR" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.driveAxleGAWR"></app-error-message>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_wheel_rimsize_text'|cxTranslate}}
                  </label>
                  <div>
                    <input formControlName="driveAxleWheelRimSize" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.driveAxleWheelRimSize"></app-error-message>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_tire_type_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="indicatetyretypeparktooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #indicatetyretypeparktooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_tire_type_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div class="form-group select-box">
                    <select formControlName="driveAxleTireType" class="form-control">
                      <option value="null" [selected]="bAF.driveAxleTireType.value == null">
                        {{'common.form_select_empty'|cxTranslate}}</option>
                      <option [value]="item.code" *ngFor="let item of tireType">{{item.name}}</option>
                    </select>
                    <app-error-message [control]="bAF.driveAxleTireType"></app-error-message>
                  </div>

                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_tire_static_text'|cxTranslate}}</label>
                  <div>
                    <input formControlName="driveAxleSLR" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                  <app-error-message [control]="bAF.driveAxleSLR"></app-error-message>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                  <label for="3dcad">{{'common.myaccount_brakeform_proposed_brake_text'|cxTranslate}}
                    <button placement="bottom" class="BAFtooltip" [tooltip]="custBraketooltip"
                      containerClass="customClass"><img src="/icons/question_dark_kb.svg" alt="Break Application Forms">
                    </button>
                  </label>
                  <ng-template #custBraketooltip>
                    <span [innerHTML]="'common.myaccount_brakeform_proposed_brake_tooltext'|cxTranslate"></span>
                  </ng-template>
                  <div>
                    <input formControlName="driveAxleCustPropBrake" type="text" class="form-control"
                      [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="AddDynamicFormButton mb-3">
            <button class="btn btn-blue" (click)="addDynamic()" [disabled]="submittedSuccessFully">
              {{'common.myaccount_brakefor_addAux_button_text'|cxTranslate}}
            </button>
          </div>
          <ng-container formArrayName="auxAxleList">
            <ng-container *ngFor="let auxInfo of auxAxleList.controls; let i=index">
              <ng-container [formGroupName]="i">
                <mat-accordion [multi]="false" [class.disable-after-submit]="submittedSuccessFully">
                  <mat-expansion-panel [expanded]="true" class="mb-3">
                    <mat-expansion-panel-header class="warranty-part-info-head">
                      <mat-panel-title>
                        {{ 'common.text_warranty_submit_part_information' | cxTranslate }} &nbsp;
                        <span class="heading-part-no">{{ '00' + (i + 1) }}</span>
                        <img src="/images/close-white.svg" class="removePartNoInfo" (click)="removeDynamic(i)"
                          alt="Close Icon">
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="dynamicFormArraySection mb-2">
                      <div class="row col-12">
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_axle_manu_text'|cxTranslate}}
                            <button placement="bottom" class="BAFtooltip" triggers="mouseenter:click"
                              [tooltip]="axlmanufacttooltip" containerClass="customClass"><img
                                src="/icons/question_dark_kb.svg">
                            </button>
                          </label>
                          <ng-template #axlmanufacttooltip>
                            <span [innerHTML]="'common.myaccount_brakeform_axle_manu_tooltext'|cxTranslate"></span>
                          </ng-template>
                          <div class="form-group select-box">
                            <select formControlName="auxAxleManu" (change)="addingdynamicFieldsinsideFormArray(i)"
                              class="form-control">
                              <option value="null">{{'common.form_select_empty'|cxTranslate}}</option>
                              <option [value]="item.code" *ngFor="let item of axleManufacturer">{{item.name}}</option>
                            </select>
                            <app-error-message [control]="getAxleListControl(i,'auxAxleManu')"></app-error-message>
                          </div>

                          <ng-container *ngIf="checkFieldIsThere(i,'auxAxleManuBox')">
                            <input type="text" placeholder="Please Specify" formControlName="auxAxleManuBox"
                              class="form-control mt-3">
                            <app-error-message [control]="getAxleListControl(i,'auxAxleManuBox')"></app-error-message>
                          </ng-container>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_brake_assembly_text'|cxTranslate}}
                            <button placement="bottom" class="BAFtooltip" [tooltip]="partyperformingBraketooltip"
                              containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                                alt="Break Application Forms">
                            </button>
                          </label>
                          <ng-template #partyperformingBraketooltip>
                            <span [innerHTML]="'common.myaccount_brakeform_brake_assembly_tooltext'|cxTranslate"></span>
                          </ng-template>
                          <div class="form-group select-box">
                            <select formControlName="auxAxleBAIP" class="form-control">
                              <option value="null">{{'common.form_select_empty'|cxTranslate}}</option>
                              <option [value]="item.code" *ngFor="let item of partPerforming">{{item.name}}</option>
                            </select>
                            <app-error-message [control]="getAxleListControl(i,'auxAxleBAIP')"></app-error-message>
                          </div>

                        </div>
                      </div>
                      <div class="row col-12">
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_axle_design_text'|cxTranslate}}
                            <button placement="bottom" class="BAFtooltip" [tooltip]="axldesigntooltip"
                              containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                                alt="Break Application Forms">
                            </button>
                          </label>
                          <ng-template #axldesigntooltip>
                            <span [innerHTML]="'common.myaccount_brakeform_axle_design_tooltext'|cxTranslate"></span>
                          </ng-template>
                          <div class="form-group select-box">
                            <select formControlName="auxAxleStatus" class="form-control">
                              <option value="null">{{'common.form_select_empty'|cxTranslate}}</option>
                              <option [value]="item.code" *ngFor="let item of axleDesign">{{item.name}}</option>
                            </select>
                            <app-error-message [control]="getAxleListControl(i,'auxAxleStatus')"></app-error-message>
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_axle_toc_text'|cxTranslate}}
                            <button placement="bottom" class="BAFtooltip" [tooltip]="tocAxleFlangetooltip"
                              containerClass="customClass"> <img src="/icons/question_dark_kb.svg"
                                alt="Break Application Forms">
                            </button>
                          </label>
                          <ng-template #tocAxleFlangetooltip>
                            <span [innerHTML]="'common.myaccount_brakeform_axle_toc_tooltext'|cxTranslate"></span>
                          </ng-template>
                          <div class="form-group select-box">
                            <select formControlName="auxAxleTOC" (change)="addingdynamicFieldsinsideFormArray(i)"
                              class="form-control">
                              <option value="null">{{'common.form_select_empty'|cxTranslate}}</option>
                              <option [value]="item.code" *ngFor="let item of tOCAxleFlange">{{item.name}}</option>
                            </select>
                            <app-error-message [control]="getAxleListControl(i,'auxAxleTOC')"></app-error-message>
                          </div>

                          <ng-container *ngIf="checkFieldIsThere(i,'auxAxleTOCBox')">
                            <input type="text" placeholder="Please Specify" formControlName="auxAxleTOCBox"
                              class="form-control mt-3" />
                            <app-error-message [control]="getAxleListControl(i,'auxAxleTOCBox')"></app-error-message>
                          </ng-container>
                        </div>
                      </div>
                      <div class="row col-12">
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_brake_disc_text'|cxTranslate}}
                            <button placement="bottom" class="BAFtooltip" [tooltip]="rotortooltip"
                              containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                                alt="Break Application Forms">
                            </button>
                          </label>
                          <ng-template #rotortooltip>
                            <span [innerHTML]="'common.myaccount_brakeform_brake_disc_tooltext'|cxTranslate"></span>
                          </ng-template>
                          <div>
                            <input formControlName="auxAxleBrakeDiscInfo" type="text" class="form-control"
                              [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                          </div>
                          <app-error-message
                            [control]="getAxleListControl(i,'auxAxleBrakeDiscInfo')"></app-error-message>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_actuator_intended_text'|cxTranslate}}
                            <button placement="bottom" class="BAFtooltip" [tooltip]="actuatortooltip"
                              containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                                alt="Break Application Forms">
                            </button>
                          </label>
                          <ng-template #actuatortooltip>
                            <span [innerHTML]="'common.myaccount_brakeform_act_intended_tooltext'|cxTranslate"></span>
                          </ng-template>
                          <div>
                            <input formControlName="auxAxleBrakeActInfo" type="text" class="form-control"
                              [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                          </div>
                          <app-error-message
                            [control]="getAxleListControl(i,'auxAxleBrakeActInfo')"></app-error-message>
                        </div>
                      </div>
                      <div class="row col-12">
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_vcp_text'|cxTranslate}}</label>
                          <div>
                            <input formControlName="auxAxleValveCP" type="text" class="form-control"
                              [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                          </div>
                          <app-error-message [control]="getAxleListControl(i,'auxAxleValveCP')"></app-error-message>
                        </div>
                      </div>
                      <div class="row col-12">
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_auxAxle_type_text'|cxTranslate}}
                            <button placement="bottom" class="BAFtooltip" [tooltip]="auxaxletypetooltip"
                              containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                                alt="Break Application Forms">
                            </button>
                          </label>
                          <ng-template #auxaxletypetooltip>
                            <span [innerHTML]="'common.myaccount_brakeform_auxAxle_type_tooltext'|cxTranslate"></span>
                          </ng-template>
                          <div class="form-group select-box">
                            <select formControlName="auxAxleType" class="form-control">
                              <option value="null">{{'common.form_select_empty'|cxTranslate}}</option>
                              <option [value]="item.code" *ngFor="let item of auxiliaryAxleType">{{item.name}}</option>
                            </select>
                            <app-error-message [control]="getAxleListControl(i,'auxAxleType')"></app-error-message>
                          </div>

                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_axle_weight_text'|cxTranslate}}
                            <button placement="bottom" class="BAFtooltip" [tooltip]="customerAxleWeighttooltip"
                              containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                                alt="Break Application Forms">
                            </button>
                          </label>
                          <ng-template #customerAxleWeighttooltip>
                            <span [innerHTML]="'common.myaccount_brakeform_axle_weight_tooltext'|cxTranslate"></span>
                          </ng-template>
                          <div>
                            <input formControlName="auxAxleWeightLimit" type="text" class="form-control"
                              [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                          </div>
                          <app-error-message [control]="getAxleListControl(i,'auxAxleWeightLimit')"></app-error-message>
                        </div>
                      </div>
                      <div class="AuxiliaryAxleAttr">
                        <div class="checkboxTitle my-3">
                          {{'common.myaccount_brakeform_auxAxle_attribute_text'|cxTranslate}}-
                          {{'common.myaccount_brakeform_check_apply'|cxTranslate}}
                          <button placement="bottom" class="BAFtooltip" [tooltip]="auxiliaryaxleattrTooltip"
                            containerClass="customClass"><img src="/icons/question_dark_kb.svg"></button>
                        </div>
                        <ng-template #auxiliaryaxleattrTooltip>
                          <span
                            [innerHTML]="'common.myaccount_brakeform_auxAxle_attribute_tooltext'|cxTranslate"></span>
                        </ng-template>
                        <div class="checkboxes" formArrayName="auxAxleAttributes">
                          <div [class.disable-after-submit]="submittedSuccessFully"
                            *ngFor="let control of getFormArrayAuxAxleAttributes(i).controls; let i = index">
                            <span><input type="checkbox" [formControlName]="i">{{addAuxleAttrContent[i]?.name}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="row col-12">
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_GAWR_lbs_text'|cxTranslate}}
                            <button placement="bottom" class="BAFtooltip" [tooltip]="brakeformgawrtooltip"
                              containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                                alt="Break Application Forms">
                            </button>
                          </label>
                          <ng-template #brakeformgawrtooltip>
                            <span [innerHTML]="'common.myaccount_brakeform_GAWR_lbs_tooltext'|cxTranslate"></span>
                          </ng-template>
                          <div>
                            <input formControlName="auxAxleGAWR" type="text" class="form-control"
                              [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                          </div>
                          <app-error-message [control]="getAxleListControl(i,'auxAxleGAWR')"></app-error-message>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_wheel_rimsize_text'|cxTranslate}}
                          </label>
                          <div>
                            <input formControlName="auxAxleWheelRimSize" type="text" class="form-control"
                              [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                          </div>
                          <app-error-message
                            [control]="getAxleListControl(i,'auxAxleWheelRimSize')"></app-error-message>
                        </div>
                      </div>
                      <div class="row col-12">
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_tire_type_text'|cxTranslate}}
                            <button placement="bottom" class="BAFtooltip" [tooltip]="auxiliarytyretypetooltip"
                              containerClass="customClass"><img src="/icons/question_dark_kb.svg"
                                alt="Break Application Forms">
                            </button>
                          </label>
                          <ng-template #auxiliarytyretypetooltip>
                            <span [innerHTML]="'common.myaccount_brakeform_tire_type_tooltext'|cxTranslate"></span>
                          </ng-template>
                          <div class="form-group select-box">
                            <select formControlName="auxAxleTireType" class="form-control">
                              <option value="null" disabled
                                [selected]="getAxleListControl(i,'auxAxleTireType').value == null">
                                {{'common.form_select_empty_axle_position'|cxTranslate}}
                              </option>
                              <option [value]="item.code" *ngFor="let item of tireType">
                                {{item.name}}
                              </option>
                            </select>
                          </div>
                          <app-error-message [control]="getAxleListControl(i,'auxAxleTireType')"></app-error-message>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_tire_static_text'|cxTranslate}}
                          </label>
                          <div>
                            <input formControlName="auxAxleSLR" type="text" class="form-control"
                              [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                          </div>
                          <app-error-message [control]="getAxleListControl(i,'auxAxleSLR')"></app-error-message>
                        </div>
                      </div>
                      <div class="row col-12">
                        <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                          <label for="3dcad">{{'common.myaccount_brakeform_proposed_brake_text'|cxTranslate}}
                            <button placement="bottom" class="BAFtooltip"
                              [tooltip]="auxiliarycustomerproposedbraketooltip" containerClass="customClass"><img
                                src="/icons/question_dark_kb.svg">
                            </button>
                          </label>
                          <ng-template #auxiliarycustomerproposedbraketooltip>
                            <span [innerHTML]="'common.myaccount_brakeform_proposed_brake_tooltext'|cxTranslate"></span>
                          </ng-template>
                          <div>
                            <input formControlName="auxAxleCustPropBrake" type="text" class="form-control"
                              [placeholder]="'common.text_adb_placeholder'|cxTranslate">
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </ng-container>
            </ng-container>
          </ng-container>

          <div class="attachementSection">
            <div class="attachments fsize_24 mb-5"><b>{{'common.#text_ADB_Commentsandattachments'|cxTranslate}}</b>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-lg-6">
                <div class="generalcommentstext fsize_20 mb-3">{{'common.text_ADB_Comments'|cxTranslate}}</div>
                <div class="textBox">
                  <textarea formControlName="customerComment" class="text-area"
                    [placeholder]="'common.text_adb_placeholder'|cxTranslate" cols="45" rows="10"></textarea>
                  <app-error-message [control]="bAF.customerComment"></app-error-message>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-lg-6 mt-4">
                <div clas="mb-2"><b>{{'common.text_warranty_note'|cxTranslate}}</b></div>
                <div class="pleaseuploadPara mb-2">{{'common.text_warranty_please_upload_all'|cxTranslate}}</div>
                <div class="viewAddBlock"><button (click)="openDialog()" [disabled]="submittedSuccessFully"
                    class="btn btn-blue view-add-btn">{{'common.text_warranty_view_add_information'|cxTranslate}}</button>
                </div>
                <div class="my-2">{{'common.text_warranty_view_max_mb'|cxTranslate}}</div>
                <ng-container *ngIf="fileLength$ | async as fileCount;else nofiles">
                  <div>({{fileCount}}&nbsp;{{'common.text_warranty_attachement_available'|cxTranslate}})</div>
                </ng-container>
                <ng-template #nofiles>
                  <div>({{0+apiFilesLength}} &nbsp;{{'common.text_warranty_attachement_available'|cxTranslate}})</div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="bottombuttonContainerDiv">
            <button class="btn btn-primary" (click)="onSave()" [disabled]="submittedSuccessFully">
              {{'common.checkout_summary_adb_saveFL'|cxTranslate}} <img width="20px" src="/icons/link-white.svg"
                alt=""></button>
            <button (click)="forReview()" [disabled]="submittedSuccessFully"
              class="btn btn-blue">{{'common.myaccount_brakeform_brake_final_review'|cxTranslate}}</button>
            <button class="btn btn-primary" (click)="onSubmit()"
              [disabled]="submittedSuccessFully || !isFormFilledSuccessfully"
              *ngIf="checkFormClicked">{{'common.checkout_multi_hostedOrderPostPage_button_submit'|cxTranslate}}
              <img width="20px" src="/icons/link-white.svg" alt=""></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>